export const TIPS = {
    NAME: {
        ROUTES: {
            HOME_VIEW: 'home_view',
            EXPEDIENTES_VIEW: 'expedientes_view',
            PERSONAS_FISICAS_VIEW: 'personas_fisicas_view',
            PERSONA_FISICA_FORM: 'persona_fisica_form',
            PERSONAS_JURIDICAS_VIEW: 'personas_juridicas_view',
            PERSONA_JURIDICA_FORM: 'persona_juridica_form',
            FIRMAS_DIGITALES_VIEW: 'firmas_digitales_view',
            LISTAS_VIEW: 'listas_view',
            ENTIDAD_FORM: 'entidad_form',
            NOT_FOUND: 'not_found',
        },
        MODALS: {
            EXPEDIENTE_MODAL_NUEVO: 'expediente_modal_nuevo',
            EXPEDIENTE_MODAL_VIEW: 'expediente_modal_view',
            ENTIDADES_MODAL: 'entidades_modal',
            ENTIDAD_MODAL: 'entidad_modal',
            PAIS_MODAL: 'pais_modal',
            PROVINCIA_MODAL: 'provincia_modal',
            LOCALIDAD_MODAL: 'localidad_modal',
            NACIONALIDAD_MODAL: 'nacionalidad_modal',
            JURISDICCION_MODAL: 'jurisdiccion_modal',
            TEMA_EXPEDIENTE_MODAL: 'tema_expediente_modal',
            INFORMACION_ADICIONAL_DOCUMENTO_MODAL: 'informacion_adicional_documento_modal',
            INFORMACION_ADICIONAL_CONTACTO_MODAL: 'informacion_adicional_contacto_modal',
            INFORMACION_ADICIONAL_MEDIO_PAGO_MODAL: 'informacion_adicional_medio_pago_modal',
            INFORMACION_ADICIONAL_PERSONA_FISICA_MODAL: 'informacion_adicional_persona_fisica_modal',
            INFORMACION_ADICIONAL_PERSONA_JURIDICA_MODAL: 'informacion_adicional_persona_juridica_modal',
            INFORMACION_ADICIONAL_EXPEDIENTE_MODAL: 'informacion_adicional_expediente_modal',
            ARCHIVO_MODAL: 'archivo_modal',
            OBSERVACION_MODAL: 'observacion_modal',
            ETIQUETA_MODAL: 'etiqueta_modal',
            USUARIO_MODAL: 'usuario_modal',
            FIRMA_DIGITAL_OBSERVACION_MODAL: 'firma_digital_observacion_modal',
            DOCUMENTO_MODAL: 'documento_modal',
            CONTACTO_MODAL: 'contacto_modal',
            MEDIO_PAGO_MODAL: 'medio_pago_modal',
            LISTAS_MODAL: 'listas_modal',
            RUBROS_AFIP_MODAL: 'rubros_afip_modal'
        }
    },
};
